import * as React from "react";
import { Navigate } from "react-router";
import { useMe } from "@/api/me";

/**
 * MV2-200 — persona-aware default landing for `/admin`.
 *
 * `AdminClientsPage` is a fleet-management table for SuperAdmin. Showing
 * it to a ClientAdmin as a 1-row "edit your own client" surface bleeds
 * SuperAdmin-shaped chrome into a context where it makes no sense.
 *
 *   * SuperAdmin   → /admin/clients (full fleet)
 *   * ClientAdmin  → /admin/customers (their customers — daily admin work)
 *
 * MV2-906 (canvas 06 `admin/AdminMobile`): admin IS a narrow-web surface —
 * read-mostly cards, create flows disabled with a reason — so a narrow
 * viewport no longer bounces to /overview. Native mobile builds are still
 * kept out by `MobileGuard` (the admin bundle is tree-shaken there).
 *
 * Backend `/admin/clients` filtering still scopes deep links for
 * ClientAdmin (defence-in-depth); this just changes the default landing.
 */
export function AdminIndexRedirect(): React.ReactElement | null {
  const { data: me, isLoading } = useMe();
  if (isLoading) return null;
  if (me?.cognito_group === "SuperAdmin") {
    return <Navigate to="clients" replace />;
  }
  return <Navigate to="customers" replace />;
}
